module.exports = __webpack_public_path__ + "img/ic_QR.f8a65a77.svg";